import { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Header from "../../NewComponents/Common/Headers/Header";
import SubHeader from "../../NewComponents/Page-2/Sub-Header/SubHeader";
import Sidebar from "../../NewComponents/Page-2/Sidebar/Sidebar";
import HotelCard from "../../NewComponents/Page-2/Hotel card/Hotel-card";
import axios from "axios";
import Pagination from "../../components/Pagination/Pagination";
import SubHeaderMobile from "../../NewComponents/Page-2/Sub-Header/SubHeader-mobile";
import HeaderMobile from "../../NewComponents/Common/Headers/Header-mobile";
import FloatingButtons from "../../NewComponents/Common/ContactButton/FloatingButtons";
import VillaCardSkeleton from "../../NewComponents/Page-2/Hotel card/VillaCardSkeleton";
import { resolveGuests, setStoredGuests } from "../../utils/guestSelection";

const hotel = {
  imageUrl:
    "https://th.bing.com/th/id/OIP.yBzy15rlMLEfll12IeotogHaE8?pid=ImgDet&rs=1",
  rating: 4,
  name: "Hotel Example",
  address: "123 Example Street, City, Country",
  area: 1000,
  bhk: 3,
  bedrooms: 3,
  bathrooms: 2,
  price: "$200",
};

const POSTS_PER_PAGE = 20;

const VillaSearchPage = () => {
  const toValidDate = (value, fallback) => {
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value;
    }
    if (typeof value === "string" && value.trim()) {
      const parsed = new Date(value);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
    }
    return fallback;
  };

  const [mobileshow, setmobileshow] = useState(
    typeof window !== "undefined" ? window.innerWidth < 1000 : false
  );
  useEffect(() => {
    function handleResize() {
      setmobileshow(window.innerWidth < 1000);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();
  const Location = useLocation();
  const formData = Location.state;

  const { city: cityParam } = useParams();
  const newcity = (cityParam || "Lonavala").replace("-", " ");
  const [villasData, setVillasData] = useState([]);
  const [isLoadingVillas, setIsLoadingVillas] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isMetaLoading, setIsMetaLoading] = useState(true);
  const [amenities, setAmenities] = useState([]);
  const [villalist, setVillalist] = useState(null);
  const [landmarklist, setlandmarklist] = useState(null);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(POSTS_PER_PAGE);
  const [totalPosts, setTotalPosts] = useState(0);
  // New random order seed on every full page refresh; reused while paginating
  const [shuffleSeed] = useState(() =>
    `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
  );
  const [queryPrefix] = useState(
    `${process.env.REACT_APP_API_AWS}/getAllVillas?`
  );
  const loadingMoreRef = useRef(false);
  const mobileshowRef = useRef(mobileshow);
  const totalPostsRef = useRef(0);
  const villasCountRef = useRef(0);

  useEffect(() => {
    mobileshowRef.current = mobileshow;
  }, [mobileshow]);

  useEffect(() => {
    totalPostsRef.current = totalPosts;
  }, [totalPosts]);

  useEffect(() => {
    villasCountRef.current = villasData.length;
  }, [villasData.length]);

  const [locationQuery, setLocationQuery] = useState("");
  const [finalQuery, setFinalQuery] = useState("");
  const [SubHeaderQuery, setSubHeaderQuery] = useState("&property_id=");

  // states for header
  const [location, setLocation] = useState(
    formData?.location || newcity
  );
  const initialGuests = resolveGuests(formData);
  const [adults, setAdults] = useState(initialGuests.adults);
  const [children, setChildren] = useState(initialGuests.children);
  const currentDate = new Date();
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const nextDayTimestamp = currentDate.getTime() + oneDayInMilliseconds;
  const nextDayDate = new Date(nextDayTimestamp);
  const [startDate, setStartDate] = useState(
    toValidDate(formData?.startDate, currentDate)
  );
  const [endDate, setEndDate] = useState(
    toValidDate(formData?.endDate, nextDayDate)
  );

  useEffect(() => {
    setStoredGuests({ adults, children });
  }, [adults, children]);

  // Prefer URL city over stale location.state from a previous search
  useEffect(() => {
    const urlCity = (cityParam || "").replace(/-/g, " ").trim();
    const city = urlCity || formData?.location || "Lonavala";
    const nextAdults = formData?.adults ?? adults ?? 2;
    const nextChildren = formData?.children ?? children ?? 0;

    setLocationQuery(
      `city=${city}&adults=${nextAdults}&children=${nextChildren}`
    );
    if (urlCity && urlCity.toLowerCase() !== String(location || "").toLowerCase()) {
      setLocation(urlCity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityParam]);

  // Default filter query so villa search runs even when amenities/sidebar are empty
  useEffect(() => {
    if (!query) {
      setQuery(
        `&min_a2z_score=0&max_a2z_score=100&min_price_guest_pay=0&max_price_guest_pay=50000&page_size=${postsPerPage}&seed=${shuffleSeed}&amenities=`
      );
    }
  }, [postsPerPage, query, shuffleSeed]);

  const filterKeyRef = useRef("");

  useEffect(() => {
    if (!locationQuery || !String(locationQuery).includes("city=")) {
      return undefined;
    }

    const controller = new AbortController();
    setIsMetaLoading(true);

    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_AWS}/getAmenitiesCity?${locationQuery}`,
          { signal: controller.signal }
        );
        window.scrollTo(0, 0);
        const payload = res.data || {};
        setAmenities(Array.isArray(payload.data) ? payload.data : []);
        setlandmarklist(
          payload.landmark != null ? payload.landmark : []
        );
        setVillalist(payload.villas != null ? payload.villas : []);
      } catch (e) {
        if (e.code === "ERR_CANCELED" || e.name === "CanceledError") {
          return;
        }
        console.error("getAmenitiesCity failed", e);
        setAmenities([]);
        setlandmarklist([]);
        setVillalist([]);
      } finally {
        if (!controller.signal.aborted) {
          setIsMetaLoading(false);
        }
      }
    })();

    return () => controller.abort();
  }, [locationQuery]);

  useEffect(() => {
    if (query === "" || !locationQuery) return;

    const filterKey = `${locationQuery}|${query}|${SubHeaderQuery}`;
    const filtersChanged =
      Boolean(filterKeyRef.current) && filterKeyRef.current !== filterKey;
    const page = filtersChanged ? 1 : currentPage;

    if (filtersChanged) {
      filterKeyRef.current = filterKey;
      if (currentPage !== 1) {
        setCurrentPage(1);
      }
      setVillasData([]);
    } else if (!filterKeyRef.current) {
      filterKeyRef.current = filterKey;
    }

    const temp =
      queryPrefix +
      locationQuery +
      query +
      SubHeaderQuery +
      `&page_number=${page}` +
      `&seed=${shuffleSeed}`;
    setFinalQuery(temp);
  }, [query, locationQuery, SubHeaderQuery, currentPage, queryPrefix, shuffleSeed]);

  const handleSearch = useCallback(async () => {
    if (!finalQuery) return;

    const isMobile = mobileshowRef.current;
    const pageMatch = finalQuery.match(/page_number=(\d+)/);
    const pageNum = pageMatch ? Number(pageMatch[1]) : 1;
    const isAppend = isMobile && pageNum > 1;

    if (isAppend) {
      setIsLoadingMore(true);
      loadingMoreRef.current = true;
    } else {
      setIsLoadingVillas(true);
      if (!isMobile || pageNum === 1) {
        setVillasData([]);
      }
    }

    try {
      const res = await axios.get(finalQuery);
      const rows = res.data.data || [];
      const apiTotal = Number(res.data.total);

      if (Number.isFinite(apiTotal) && apiTotal >= 0) {
        setTotalPosts(apiTotal);
      } else {
        setTotalPosts(
          (pageNum - 1) * postsPerPage +
            rows.length +
            (rows.length >= postsPerPage ? postsPerPage : 0)
        );
      }

      if (isAppend) {
        setVillasData((prev) => {
          const seen = new Set(
            prev.map((v) => v.id || v.property_ptr_id)
          );
          const next = rows.filter(
            (v) => !seen.has(v.id || v.property_ptr_id)
          );
          return [...prev, ...next];
        });
      } else {
        setVillasData(rows);
      }
    } catch (e) {
      console.error("Villa search failed", e);
      if (!isAppend) {
        setVillasData([]);
        setTotalPosts(0);
      }
    } finally {
      setIsLoadingVillas(false);
      setIsLoadingMore(false);
      loadingMoreRef.current = false;
      if (!isAppend) {
        window.scrollTo(0, 0);
      }
    }
  }, [finalQuery, postsPerPage]);

  useEffect(() => {
    if (finalQuery !== "") {
      handleSearch();
    }
  }, [finalQuery, handleSearch]);

  // Mobile infinite scroll
  useEffect(() => {
    if (!mobileshow) return undefined;

    const onScroll = () => {
      if (loadingMoreRef.current || isLoadingVillas || isLoadingMore) return;
      if (villasCountRef.current >= totalPostsRef.current) return;
      if (totalPostsRef.current <= 0) return;

      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 500;

      if (nearBottom) {
        loadingMoreRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [mobileshow, isLoadingVillas, isLoadingMore]);

  const handleCardClick = (villaId, villaName) => {
    const formData2 = {
      villaId: villaId,
      villaName: villaName,
      location: location,
      startDate: startDate,
      endDate: endDate,
      adults: adults,
      children: children,
    };
    setStoredGuests({ adults, children });
    const hyphenatedVillaName = villaName.replace(/\s+/g, "-");
    const url = `/villa/${villaId}/${hyphenatedVillaName}?formData=${encodeURIComponent(JSON.stringify(formData2))}`;

    const newTab = window.open(url, "_blank");
    if (!newTab) {
      navigate(url);
    }
  };

  const handleSearchClick = (nextLocation) => {
    const destination = (
      (typeof nextLocation === "string" && nextLocation.trim()) ||
      location ||
      newcity ||
      ""
    ).trim();

    if (!destination) return;

    let diffTime;
    if (endDate instanceof Date && startDate instanceof Date) {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    } else diffTime = 0;
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    let tempStartDate =
      startDate instanceof Date
        ? startDate
            .toLocaleDateString("en-US", { timeZone: "Asia/Kolkata" })
            .slice(0, 10)
        : null;

    if (startDate instanceof Date && tempStartDate) {
      let dateStr = tempStartDate;
      let [month, day, year] = dateStr.split("/");
      tempStartDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    let newEndDate = null;
    if (endDate instanceof Date) {
      newEndDate = new Date(endDate.getTime());
      newEndDate.setDate(newEndDate.getDate() - 1);
    }
    let tempEndDate = newEndDate
      ?.toLocaleDateString("en-US", { timeZone: "Asia/Kolkata" })
      .slice(0, 10);
    if (newEndDate instanceof Date && tempEndDate) {
      let dateStr = tempEndDate;
      let [month, day, year] = dateStr.split("/");
      tempEndDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    const temp = `city=${destination}&adults=${adults}&children=${children}&startDate=${tempStartDate}&endDate=${tempEndDate}&days=${days}`;
    setLocation(destination);
    setLocationQuery(temp);
    setCurrentPage(1);
    setVillasData([]);

    const slug = destination.replace(/\s+/g, "-");
    setStoredGuests({ adults, children });
    navigate(`/search/${slug}`, {
      replace: true,
      state: {
        location: destination,
        startDate,
        endDate,
        adults,
        children,
      },
    });
  };

  useEffect(() => {
    handleSearchClick(location || newcity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hasMore = villasData.length < totalPosts;

  return (
    <>
      <FloatingButtons />
      {isMetaLoading ? (
        <div className="flex justify-center items-center h-screen">
          <img
            src="https://cdn.dribbble.com/users/563824/screenshots/3633228/media/d876c7712d969c0656302b16b16af2cc.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="h-full ">
          {!mobileshow ? (
            <Header
              location={location}
              setLocation={setLocation}
              setAdults={setAdults}
              adults={adults}
              children={children}
              setChildren={setChildren}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleSearchClick={handleSearchClick}
              check={true}
            />
          ) : (
            <HeaderMobile
              location={location}
              setLocation={setLocation}
              setAdults={setAdults}
              adults={adults}
              children={children}
              setChildren={setChildren}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleSearchClick={handleSearchClick}
              check={true}
            />
          )}

          {!mobileshow && (
            <SubHeader
              setSubHeaderQuery={setSubHeaderQuery}
              villalist={villalist || []}
              landmarklist={landmarklist || []}
              amenities={amenities}
              query={query}
              setQuery={setQuery}
            />
          )}
          <div className="grid grid-cols-1 lg:grid-cols-[repeat(13,minmax(0,1fr))] mr-0 md:mr-4">
            <div className="col-span-1 lg:col-span-3 hidden lg:block">
              <Sidebar amenities={amenities} query={query} setQuery={setQuery} />
            </div>
            <div className="col-span-1 lg:col-span-10">
              {isLoadingVillas && villasData.length === 0 ? (
                <div>
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <VillaCardSkeleton key={i} />
                  ))}
                </div>
              ) : villasData.length > 0 ? (
                <div>
                  {villasData.map((villadata) => (
                    <div key={villadata.id || villadata.property_ptr_id}>
                      <HotelCard
                        hotel={hotel}
                        city={cityParam}
                        villadata={villadata}
                        amenitiesAll={amenities}
                        handleCardClick={handleCardClick}
                        startDate={startDate}
                        endDate={endDate}
                        adults={adults}
                        children={children}
                        citylocation={location}
                      />
                    </div>
                  ))}

                  {/* Desktop: numbered pagination */}
                  {!mobileshow && (
                    <Pagination
                      totalPosts={totalPosts}
                      postsPerPage={postsPerPage}
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                    />
                  )}

                  {/* Mobile: scroll pagination status */}
                  {mobileshow && (
                    <div className="py-6 px-4 text-center">
                      {isLoadingMore ? (
                        <div>
                          {[1, 2].map((i) => (
                            <VillaCardSkeleton key={`more-${i}`} />
                          ))}
                        </div>
                      ) : hasMore ? (
                        <p className="text-sm text-gray-500">
                          Scroll for more villas
                        </p>
                      ) : (
                        <p className="text-sm text-gray-400">
                          Showing all {totalPosts} villa
                          {totalPosts === 1 ? "" : "s"}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div className="w-full mt-[20vh] flex flex-col items-center mb-10 px-4 text-center">
                  <p className="text-lg font-semibold text-gray-600">
                    No villas found
                  </p>
                  <p className="text-sm text-gray-400 mt-2">
                    Try a different destination or adjust your dates
                  </p>
                </div>
              )}
            </div>
          </div>
          {mobileshow && (
            <SubHeaderMobile
              setSubHeaderQuery={setSubHeaderQuery}
              villalist={villalist || []}
              landmarklist={landmarklist || []}
              amenities={amenities}
              query={query}
              setQuery={setQuery}
            />
          )}
        </div>
      )}
    </>
  );
};

export default VillaSearchPage;
